import SigninForm from "./SigninForm";

interface Props { }

function Signin(props: Props) {
  return <SigninForm />
}

export default Signin;